import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { RecaptchaComponent } from 'ng-recaptcha';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sign-up3',
  templateUrl: './sign-up3.component.html',
  styleUrls: ['./sign-up3.component.css']
})
export class SignUp3Component implements OnInit {

    //Pattern
    phonePattern ="^((\\+91-?)|0)?[0-9]{10}$";

  // TODO: Create a user model instead?
  user = {
    annualIncome: '',
    sourceOfIncome: '',
    streetAddress: '',
    secondary: '',
    phone: '',
    city: '',
    state: '',
    zipCode: '',
    county: '',
    primaryResidence: '',
    livingSituation: '',
    coordinates: '',
    actualState: '',
    captcha: '',
  }

  eulaModel = {
    eula: ''
  }

  geolocating = false;
  submitting = false;
  submitted  = false;

  @ViewChild(RecaptchaComponent, { static: false })
  recaptcha?: RecaptchaComponent;
  recaptchaEnabled = environment.recaptcha.enabled;

  constructor(private userService: UserService, private router: Router) { }

  ngOnInit(): void {
    if (!this.userService.user.signup) {
      this.router.navigate(['/sign-up']);
      return;
    }
  }

  private async checkGeolocation(): Promise<{ position?: GeolocationPosition, error?: GeolocationPositionError }> {
    this.geolocating = true;

    try {
      this.user.coordinates = '';
      this.user.actualState = '';

      const position = await this.userService.getCurrentPosition({ timeout: 10000 });

      const coords = { latitude: position.coords.latitude, longitude: position.coords.longitude };
      // const coords = { latitude: 41.2259616033894, longitude: -95.92708784428619 }; // Nebraska zoo
      // const coords = { latitude: 40.78318752447714, longitude: -73.97784977757433 }; // New York zoo

      this.user.coordinates = coords as any;

      const result = await this.userService.findAddress(coords).toPromise();

      const address = result?.address_components || {};

      this.user.actualState = address.country === 'US' ? address.state : '';

      return { position };
    }
    catch (error) {
      if (error instanceof GeolocationPositionError) {
        return { error };
      }
      else {
        throw error;
      }
    }
    finally {
      this.geolocating = false;
    }
  }

  // Update user in UserService TODO: Theres a better way of doing this
  async onSubmit(form: FormGroup) {
    this.submitted = true;

    if (this.geolocating) {
      return;
    }

    if (this.submitting) {
      return;
    }

    if (form.invalid) {
      return;
    }

    this.submitting = true;

    try {
      this.userService.user.annualIncome = this.user.annualIncome;
      this.userService.user.sourceOfIncome = this.user.sourceOfIncome;
      this.userService.user.streetAddress = this.user.streetAddress;
      this.userService.user.secondary = this.user.secondary;
      this.userService.user.phone = this.user.phone;
      this.userService.user.city = this.user.city;
      this.userService.user.state = this.user.state;
      this.userService.user.zipCode = this.user.zipCode;
      this.userService.user.county = this.user.county;
      this.userService.user.primaryResidence = this.user.primaryResidence;
      this.userService.user.livingSituation = this.user.livingSituation;
      this.userService.user.coordinates = this.user.coordinates;
      this.userService.user.actualState = this.user.actualState;

      // Check if user is actually in Nebraska state and can sign up for free
      if (this.userService.user.state === 'NE') {
        const { error } = await this.checkGeolocation();

        this.userService.user.coordinates = this.user.coordinates;
        this.userService.user.actualState = this.user.actualState;

        if (error) {
          this.submitted = false;

          if (error.code === GeolocationPositionError.PERMISSION_DENIED) {
            if (confirm('Allow location access to check if you are in Nebraska and can sign up for free.')) {
              return;
            }
            else {
              this.router.navigate(['/sign-up4']);
              return;
            }
          }
          else {
            if (confirm('Unable to access your location to check if you are in Nebraska and can sign up for free. Please check location settings in browser and try again.')) {
              return;
            }
          }
        }

        if (!this.user.actualState) {
          alert("Unable to check your location if you are in Nebraska and can sign up for free.");
          this.router.navigate(['/sign-up4']);
          return;
        }

        if (this.user.actualState !== 'NE') {
          alert("Your current location is outside Nebraska, you will have to pay $30 + processing fees for registration.");
          this.router.navigate(['/sign-up4']);
          return;
        }
      }
      else {
        this.router.navigate(['/sign-up4']);
        return;
      }

      const registered = await this.userService.register(this.userService.user, this.user.captcha, null).catch(err => {
        this.user.captcha = '';
        this.recaptcha?.reset();
        this.submitted = false;
        throw err;
      });

      if (!registered) {
        this.user.captcha = '';
        this.recaptcha?.reset();
        this.submitted = false;
      }
    }
    finally {
      this.submitting = false;
    }
  }
}
